import React from 'react';
import { Link } from 'react-router-dom';
import './Shared-Formatting.css';

function Article1() {
  return (
    <div className="article-wrapper">
      <article className="article-container">
        <h1 className="article-title">Why AI Development is a Suicidal Endeavor</h1>
        <div className="article-meta">
        <span>Last updated on: June 26th, 2025</span> | <span>Originally published on: June 26th, 2025</span> |  <span>Author: Isaiah Milbank</span>
        </div>
        <div className="article-content">
          <p>
          The goal of this document is to explain the reasonableness of a seemingly outlandish view of the near future to my friends and family. It should be something I can point to that has my core justifications documented in an easily-absorbable form. To that end, the arguments should be simple, short, and lacking in jargon. 
          It is also meant to be a living document, growing and changing in response to the questions and feedback I get from those closest to me.
          </p>
          <h2>Why superintelligence is dangerous</h2>
          <h3>Instrumental Convergence</h3>
          <p>I promised no jargon, but instrumental convergence is a fairly simple concept that is fundamental to my understanding of the problem. 
            Instrumental convergence is the natural tendency of different end goals to share useful sub-goals. It allows us to make naive assumptions about
            what type of things an AI might wish to accomplish, and it just so happens that a lot of these wishes are in conflict with human life. 
            
            </p>
            <h3> What are some instrumentally convergent goals?</h3>
            <ol>
              <li>Resource Gathering</li>
              <dl>Most goals are in some sense material. If you want to grow, if you want to construct something, you need physical resources. </dl>
              <li>Self-Preservation</li>
              <dl>Consider two worlds: One where you exist, and one where you cease to exist. In which world is your goal more likely to be attained?</dl>
              <li>Agency/Power Seeking</li>
              <dl></dl>
            </ol>
          <h2>Why superintelligence is likely</h2>
          <p> </p>
          <h2>Why it's a hard problem</h2>
          <p> </p>
        </div>
        <footer className="article-footer">
          <p>Thanks for reading! Check out more articles in the <Link to="/articles">Articles</Link> section.</p>
        </footer>
      </article>
    </div>
  );
}

export default Article1;
